import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=6cec2283&scoped=true&"
import script from "./BoardCard.vue?vue&type=script&lang=js&"
export * from "./BoardCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=6cec2283&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec2283",
  null
  
)

export default component.exports